import type {
  IndicesChart5Setting,
  IndicesChartOption,
} from '@app-types/indices';

const publicBase = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '');

// export const INDICES_CHART_BUNDLE_URL = `${publicBase}/chart-bundle/index.html`;

export const INDICES_CHART_BUNDLE_URL = `${publicBase}/build/index.html`;

export const INDICES_CHART5_SETTING: IndicesChart5Setting = {
  priceTrackColor: '838383',
  priceTrackFontColor: 'FFFFFF',
  priceTrackThinkness: 2,
  priceTrackStyle: 'd',
  yAsis: false,
  backgroundColor: 'FFFFFF',
  chartBackgroundColor: 'FFFFFF',
  chartLineColor: 'C6D1CC',
  chartLineStyle: 's',
  toolTipsColor: '67727A',
  crosshairLineColor: '444444',
  crosshairLineStyle: 's',
  crosshairPointColor: 'FF0000',
  crosshairPointSize: '0',
  crosshairFontColor: 'FFFFFF',
  preserveYAxisTrailingZeros: true,
  autoYAxisLabelWidth: true,
};

export const INDICES_CHART_OPTION: IndicesChartOption = {
  lineColor: '2352D6',
  lineFillColor: '2352D6',
  lineFillColor2: 'FFFFFF',
  lineGradientEnable: false,
  lineStyle: 's',
  lineThickness: 2,
  upColor: 'CC0100',
  upFillColor: 'CC0100',
  downColor: '3366FF',
  downFillColor: '3366FF',
  barColor: '3386FF',
  bar3lineColor: '3386FF',
  histogramUpColor: 'DDDDDD',
  histogramUpFillColor: '99CCFF',
  histogramDownColor: 'DDDDDD',
  histogramDownFillColor: '99CCFF',
  showTracker: false,
};

export const INDICES_POPUP_OVERLAY = {
  SMA: [
    { enabled: true, period: '5', color: 'D14A4A', thickness: 2, style: 's', showTracker: false },
    { enabled: true, period: '25', color: '7E3CC8', thickness: 2, style: 's', showTracker: false },
    { enabled: true, period: '75', color: 'D99090', thickness: 2, style: 's', showTracker: false },
  ],
};
